import React, { createContext, useContext, useEffect, useState } from "react";
import { getCurrentUser, logoutUser as apiLogout } from "../services/UserService.ts"; // Assuming you have a logout service function
import { setupAuthInterceptor } from "../services/api.ts";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const logout = async () => {
    try {
      await apiLogout(); // Call the backend to destroy the session
    } catch (error) {
      console.error("Failed to logout on server", error);
    } finally {
      setIsLoggedIn(false);
    }
  };

  const checkAuth = async () => {
    setLoading(true);
    try {
      await getCurrentUser();
      setIsLoggedIn(true);
    } catch (error) {
      setIsLoggedIn(false);
      console.log("User not authenticated");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Setup the interceptor on component mount
    setupAuthInterceptor(logout);
    checkAuth();
  }, []);

  const login = () => setIsLoggedIn(true);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, checkAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}